const toolbar =
{
    search : 'Rechercher' ,
    title  : process.env.REACT_APP_TITLE
};

export default toolbar ;
